document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.responsibile-production');
  if (!sections.length) return;

  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const END_SHIFT = 580; // конечная точка, подбирай только это число

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function updateSection(section) {
    const leftInner = section.querySelector('.left-production-inner');
    const contactBlock = section.querySelector('.responsibility-production-contact');

    if (!leftInner || !contactBlock) return;

    if (!desktopQuery.matches) {
      leftInner.style.transform = 'translateY(0px)';
      return;
    }

    const rect = contactBlock.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    const startPoint = viewportHeight*0.75; // точка, в которой начинается движение, подбирай только это число
    const endPoint = -rect.height; // точка, в которой заканчивается движение, подбирай только это число

    const progress = clamp((startPoint - rect.top) / (startPoint - endPoint), 0, 1);
    const shift = END_SHIFT * progress;

    leftInner.style.transform = `translateY(${shift}px)`;
  }

  function updateAll() {
    sections.forEach(updateSection);
  }

  updateAll();
  window.addEventListener('scroll', updateAll, { passive: true });
  window.addEventListener('resize', updateAll);
  window.addEventListener('load', updateAll);
});